var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValorantLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.718 6.763V.846c0-.091-.114-.13-.175-.061L9.08 8.862c-.054.06-.008.16.076.16h4.67a.4.4 0 00.319-.16l1.475-1.84a.39.39 0 00.1-.26zm-15.12.266l4.853 6.069a.408.408 0 00.327.152h4.67c.083 0 .129-.091.076-.152L.674.793C.615.724.5.763.5.853V6.77a.473.473 0 00.099.259z",
    fill: "#CDDCFE"
  })));
}
export default __webpack_public_path__ + "static/svg/valorant-logo.svg";
export { SvgValorantLogo as ReactComponent };